<template>
    <div class="divider-wrapper">
        <div
            class="left-border"
            :style="{
                width: borderWidth,
            }"
        />
        <div ref="contentSlot">
            <slot name="default" />
        </div>
        <div
            class="right-border"
            :style="{
                width: borderWidth,
            }"
        />
    </div>
</template>

<script>
export default {
    name: "BasicDivider",
    data() {
        return {
            slotDefault: null,
            slotWidth: 0,
        }
    },
    computed: {
        borderWidth() {
            return `calc((100% - ${this.slotWidth}px) / 2 - 0.5em)`
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.contentSlot) {
                this.slotWidth = this.$refs.contentSlot.offsetWidth
            }
        })
    },
}
</script>

<style lang="scss" scoped>
.divider-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5em;

    .left-border,
    .right-border {
        height: 1px;
        border-radius: 99px;
        border-top: 1px solid black;
    }
}
</style>
